import type { PersonaDto } from '@/lib/api/personas-client';
import { BIOGRAPHY_ITEM_LABELS, type BiographyItemLabel } from '../model';

export interface BiographyItem {
  label: BiographyItemLabel;
  value: string;
}

function formatSentences(values?: string[]): string {
  if (!values?.length) return '';
  return values.map((s) => s.trimEnd().replace(/\.$/, '')).join('. ') + '.';
}

function getBiographyItemValue(label: BiographyItemLabel, persona: PersonaDto): string {
  switch (label) {
    case 'Career':
      return persona.demographicsData?.data.careerDescription || '';
    case 'Lifestyle':
      return formatSentences(persona.psychometricsData?.data.CFC.cultureNorms.lifestyle);
    case 'Social Media':
      return formatSentences(persona.socialMediaData?.characteristics);
    case 'Values':
      return formatSentences(persona.psychometricsData?.data.CFC.cultureNorms.socialValues);
  }
}

export function getBiographyItems<T = BiographyItem>(
  persona: PersonaDto,
  mapper?: (item: BiographyItem) => T,
): T[] {
  return BIOGRAPHY_ITEM_LABELS.flatMap((label) => {
    const value = getBiographyItemValue(label, persona);
    if (!value) return [];

    const item = {
      label,
      value,
    };
    return mapper ? [mapper(item)] : [item as T];
  });
}
